import { deepEqual } from './object';
import { AccountT, RegistrationDataT } from '../types';

export const modifiedAccountFields = (remoteAccount: AccountT, registrationData: Partial<RegistrationDataT>) => {
  const modifiedFields: Partial<RegistrationDataT> = {};

  if (!deepEqual(remoteAccount.address, registrationData.address)) {
    modifiedFields.address = registrationData.address;
  }

  if (!deepEqual(remoteAccount.phoneNumber, registrationData.phoneNumber)) {
    modifiedFields.phoneNumber = registrationData.phoneNumber;
  }

  if (!deepEqual(remoteAccount.maritalInformation, registrationData.maritalInformation)) {
    modifiedFields.maritalInformation = registrationData.maritalInformation;
  }

  return modifiedFields;
};
